export const SERVICE_LIST_REQUEST = "SERVICE_LIST_REQUEST";
export const SERVICE_LIST_SUCCESS = "SERVICE_LIST_SUCCESS";
export const SERVICE_LIST_FAIL = "SERVICE_LIST_FAIL";

export const SERVICE_BOOKING_CREATE_REQUEST =
  "SERVICE_BOOKING_CREATE_REQUEST";
export const SERVICE_BOOKING_CREATE_SUCCESS =
  "SERVICE_BOOKING_CREATE_SUCCESS";
export const SERVICE_BOOKING_CREATE_FAIL = "SERVICE_BOOKING_CREATE_FAIL";
export const SERVICE_BOOKING_CREATE_RESET = "SERVICE_BOOKING_CREATE_RESET";

export const SERVICE_ORDER_QUOTE_REQUEST = "SERVICE_ORDER_QUOTE_REQUEST";
export const SERVICE_ORDER_QUOTE_SUCCESS = "SERVICE_ORDER_QUOTE_SUCCESS";
export const SERVICE_ORDER_QUOTE_FAIL = "SERVICE_ORDER_QUOTE_FAIL";
export const SERVICE_ORDER_QUOTE_RESET = "SERVICE_ORDER_QUOTE_RESET";

export const SERVICE_ORDER_CREATE_REQUEST = "SERVICE_ORDER_CREATE_REQUEST";
export const SERVICE_ORDER_CREATE_SUCCESS = "SERVICE_ORDER_CREATE_SUCCESS";
export const SERVICE_ORDER_CREATE_FAIL = "SERVICE_ORDER_CREATE_FAIL";
export const SERVICE_ORDER_CREATE_RESET = "SERVICE_ORDER_CREATE_RESET";

export const SERVICE_ORDER_DETAILS_REQUEST = "SERVICE_ORDER_DETAILS_REQUEST";
export const SERVICE_ORDER_DETAILS_SUCCESS = "SERVICE_ORDER_DETAILS_SUCCESS";
export const SERVICE_ORDER_DETAILS_FAIL = "SERVICE_ORDER_DETAILS_FAIL";
export const SERVICE_ORDER_DETAILS_RESET = "SERVICE_ORDER_DETAILS_RESET";

export const SERVICE_ORDER_PAYMENT_REQUEST = "SERVICE_ORDER_PAYMENT_REQUEST";
export const SERVICE_ORDER_PAYMENT_SUCCESS = "SERVICE_ORDER_PAYMENT_SUCCESS";
export const SERVICE_ORDER_PAYMENT_FAIL = "SERVICE_ORDER_PAYMENT_FAIL";
export const SERVICE_ORDER_PAYMENT_RESET = "SERVICE_ORDER_PAYMENT_RESET";

export const SERVICE_ORDER_MESSAGE_REQUEST = "SERVICE_ORDER_MESSAGE_REQUEST";
export const SERVICE_ORDER_MESSAGE_SUCCESS = "SERVICE_ORDER_MESSAGE_SUCCESS";
export const SERVICE_ORDER_MESSAGE_FAIL = "SERVICE_ORDER_MESSAGE_FAIL";
export const SERVICE_ORDER_MESSAGE_RESET = "SERVICE_ORDER_MESSAGE_RESET";

export const SERVICE_ORDER_ADJUSTMENT_RESPONSE_REQUEST =
  "SERVICE_ORDER_ADJUSTMENT_RESPONSE_REQUEST";
export const SERVICE_ORDER_ADJUSTMENT_RESPONSE_SUCCESS =
  "SERVICE_ORDER_ADJUSTMENT_RESPONSE_SUCCESS";
export const SERVICE_ORDER_ADJUSTMENT_RESPONSE_FAIL =
  "SERVICE_ORDER_ADJUSTMENT_RESPONSE_FAIL";
export const SERVICE_ORDER_ADJUSTMENT_RESPONSE_RESET =
  "SERVICE_ORDER_ADJUSTMENT_RESPONSE_RESET";

export const ADMIN_SERVICE_LIST_REQUEST = "ADMIN_SERVICE_LIST_REQUEST";
export const ADMIN_SERVICE_LIST_SUCCESS = "ADMIN_SERVICE_LIST_SUCCESS";
export const ADMIN_SERVICE_LIST_FAIL = "ADMIN_SERVICE_LIST_FAIL";

export const ADMIN_SERVICE_DETAILS_REQUEST = "ADMIN_SERVICE_DETAILS_REQUEST";
export const ADMIN_SERVICE_DETAILS_SUCCESS = "ADMIN_SERVICE_DETAILS_SUCCESS";
export const ADMIN_SERVICE_DETAILS_FAIL = "ADMIN_SERVICE_DETAILS_FAIL";

export const ADMIN_SERVICE_CREATE_REQUEST = "ADMIN_SERVICE_CREATE_REQUEST";
export const ADMIN_SERVICE_CREATE_SUCCESS = "ADMIN_SERVICE_CREATE_SUCCESS";
export const ADMIN_SERVICE_CREATE_FAIL = "ADMIN_SERVICE_CREATE_FAIL";
export const ADMIN_SERVICE_CREATE_RESET = "ADMIN_SERVICE_CREATE_RESET";

export const ADMIN_SERVICE_UPDATE_REQUEST = "ADMIN_SERVICE_UPDATE_REQUEST";
export const ADMIN_SERVICE_UPDATE_SUCCESS = "ADMIN_SERVICE_UPDATE_SUCCESS";
export const ADMIN_SERVICE_UPDATE_FAIL = "ADMIN_SERVICE_UPDATE_FAIL";
export const ADMIN_SERVICE_UPDATE_RESET = "ADMIN_SERVICE_UPDATE_RESET";

export const ADMIN_SERVICE_DELETE_REQUEST = "ADMIN_SERVICE_DELETE_REQUEST";
export const ADMIN_SERVICE_DELETE_SUCCESS = "ADMIN_SERVICE_DELETE_SUCCESS";
export const ADMIN_SERVICE_DELETE_FAIL = "ADMIN_SERVICE_DELETE_FAIL";
export const ADMIN_SERVICE_DELETE_RESET = "ADMIN_SERVICE_DELETE_RESET";

export const ADMIN_SERVICE_BOOKING_LIST_REQUEST =
  "ADMIN_SERVICE_BOOKING_LIST_REQUEST";
export const ADMIN_SERVICE_BOOKING_LIST_SUCCESS =
  "ADMIN_SERVICE_BOOKING_LIST_SUCCESS";
export const ADMIN_SERVICE_BOOKING_LIST_FAIL =
  "ADMIN_SERVICE_BOOKING_LIST_FAIL";

export const ADMIN_SERVICE_BOOKING_UPDATE_REQUEST =
  "ADMIN_SERVICE_BOOKING_UPDATE_REQUEST";
export const ADMIN_SERVICE_BOOKING_UPDATE_SUCCESS =
  "ADMIN_SERVICE_BOOKING_UPDATE_SUCCESS";
export const ADMIN_SERVICE_BOOKING_UPDATE_FAIL =
  "ADMIN_SERVICE_BOOKING_UPDATE_FAIL";
export const ADMIN_SERVICE_BOOKING_UPDATE_RESET =
  "ADMIN_SERVICE_BOOKING_UPDATE_RESET";

export const ADMIN_SERVICE_BOOKING_DELETE_REQUEST =
  "ADMIN_SERVICE_BOOKING_DELETE_REQUEST";
export const ADMIN_SERVICE_BOOKING_DELETE_SUCCESS =
  "ADMIN_SERVICE_BOOKING_DELETE_SUCCESS";
export const ADMIN_SERVICE_BOOKING_DELETE_FAIL =
  "ADMIN_SERVICE_BOOKING_DELETE_FAIL";
export const ADMIN_SERVICE_BOOKING_DELETE_RESET =
  "ADMIN_SERVICE_BOOKING_DELETE_RESET";

export const ADMIN_SERVICE_ORDER_LIST_REQUEST =
  "ADMIN_SERVICE_ORDER_LIST_REQUEST";
export const ADMIN_SERVICE_ORDER_LIST_SUCCESS =
  "ADMIN_SERVICE_ORDER_LIST_SUCCESS";
export const ADMIN_SERVICE_ORDER_LIST_FAIL = "ADMIN_SERVICE_ORDER_LIST_FAIL";

export const ADMIN_SERVICE_ORDER_DETAILS_REQUEST =
  "ADMIN_SERVICE_ORDER_DETAILS_REQUEST";
export const ADMIN_SERVICE_ORDER_DETAILS_SUCCESS =
  "ADMIN_SERVICE_ORDER_DETAILS_SUCCESS";
export const ADMIN_SERVICE_ORDER_DETAILS_FAIL =
  "ADMIN_SERVICE_ORDER_DETAILS_FAIL";
export const ADMIN_SERVICE_ORDER_DETAILS_RESET =
  "ADMIN_SERVICE_ORDER_DETAILS_RESET";

export const ADMIN_SERVICE_ORDER_UPDATE_REQUEST =
  "ADMIN_SERVICE_ORDER_UPDATE_REQUEST";
export const ADMIN_SERVICE_ORDER_UPDATE_SUCCESS =
  "ADMIN_SERVICE_ORDER_UPDATE_SUCCESS";
export const ADMIN_SERVICE_ORDER_UPDATE_FAIL =
  "ADMIN_SERVICE_ORDER_UPDATE_FAIL";
export const ADMIN_SERVICE_ORDER_UPDATE_RESET =
  "ADMIN_SERVICE_ORDER_UPDATE_RESET";

export const ADMIN_SERVICE_ORDER_MESSAGE_REQUEST =
  "ADMIN_SERVICE_ORDER_MESSAGE_REQUEST";
export const ADMIN_SERVICE_ORDER_MESSAGE_SUCCESS =
  "ADMIN_SERVICE_ORDER_MESSAGE_SUCCESS";
export const ADMIN_SERVICE_ORDER_MESSAGE_FAIL =
  "ADMIN_SERVICE_ORDER_MESSAGE_FAIL";
export const ADMIN_SERVICE_ORDER_MESSAGE_RESET =
  "ADMIN_SERVICE_ORDER_MESSAGE_RESET";

export const ADMIN_SERVICE_ORDER_ADJUSTMENT_REQUEST =
  "ADMIN_SERVICE_ORDER_ADJUSTMENT_REQUEST";
export const ADMIN_SERVICE_ORDER_ADJUSTMENT_SUCCESS =
  "ADMIN_SERVICE_ORDER_ADJUSTMENT_SUCCESS";
export const ADMIN_SERVICE_ORDER_ADJUSTMENT_FAIL =
  "ADMIN_SERVICE_ORDER_ADJUSTMENT_FAIL";
export const ADMIN_SERVICE_ORDER_ADJUSTMENT_RESET =
  "ADMIN_SERVICE_ORDER_ADJUSTMENT_RESET";
